module.exports = __webpack_public_path__ + "img/Empire.765759f2.jpg";